import { useState } from "react";

import PropTypes from "prop-types";

import { DecrementIcon, IncrementIcon } from "../icon";
import Styles from "./Collapse.module.css";

function Collapse({ headingText, bodyText }) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={Styles.faq}>
      <details open={!isCollapsed}>
        <summary className="flex w-full cursor-pointer items-center justify-between text-[1.25rem] font-semibold">
          <p>{headingText}</p>
          <div>
            <button className={Styles.collapse} onClick={toggleCollapse}>
              <IncrementIcon className="h-[3rem] w-[3rem] text-primary" />
            </button>
            <button className={Styles.expend} onClick={toggleCollapse}>
              <DecrementIcon className="h-[3rem] w-[3rem] text-primary" />
            </button>
          </div>
        </summary>
        <p className="mt-[1.188rem] text-justify text-[1rem] leading-relaxed">
          {bodyText}
        </p>
      </details>
    </div>
  );
}

export default Collapse;

Collapse.propTypes = {
  headingText: PropTypes.string,
  bodyText: PropTypes.string,
};
